export default {
  type: 'stocker',
  description: 'AS/RS Stocker',
  group: '3D',
  icon: undefined,
  model: {
    type: 'stocker',
    left: 100,
    top: 100,
    width: 300,
    height: 150,
    depth: 80,
    fillStyle: 'rgba(200,200,200,0.4)',
    strokeStyle: '#999',
    lBays: 10,
    lLevels: 5,
    lDepth: 1,
    cranes: 1,
    rBays: 10,
    rLevels: 5,
    rDepth: 1,
    frontSide: 'auto',
    aisleRatio: 0.15,
    locationRule: JSON.stringify({
      pattern: '{side}{bay}-{level}-{depth}',
      sideLabels: { L: 'L', R: 'R' },
      bayDir: 'ltr',
      levelDir: 'btt',
      bayStart: 1,
      levelStart: 1,
      depthStart: 1,
      bayDigits: 2,
      levelDigits: 2,
      depthDigits: 0
    })
  }
}
